var _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _path7, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagForVaticanCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 32C62 15.4 48.6 2 32 2v60c16.6 0 30-13.4 30-30",
    fill: "#f9f9f9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 32c0 16.6 13.4 30 30 30V2C15.4 2 2 15.4 2 32z",
    fill: "#ffe62e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 21.3c0 2.9 0 3.8-3 3.8s-3-.9-3-3.8s1.3-5.3 3-5.3s3 2.4 3 5.3",
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#dbb471"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5 17.8L46 16.6l-1.5 1.2l-1.5-1.2l.5 2.4h5l.5-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 20.6L46 19.2l-1.5 1.4l-1.5-1.4V22h6v-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5 23.5L46 22l-1.5 1.5L43 22v3h6v-3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46,
    cy: 15.1,
    rx: 0.5,
    ry: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 46,
    cy: 25,
    rx: 3,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9 32.6c-1.4 0-2.5-2.1-2.6-2.8c-.2-1 .3-2 .8-3.1c.3-.5.7-1.6.7-1.9c-.1-.4-1.2-1.5-2.3-2.3l1.2-1.6c.8.6 2.7 2.3 3 3.4c.2 1-.3 2-.8 3.2c-.3.6-.7 1.5-.7 1.9c.1.3.4.8.7 1.1c.5-.5 1.3-2.9 1.7-5.3l2 .3c-.4 2.5-1.4 6.7-3.4 7c-.1.1-.2.1-.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1 32.6h-.2c-2.1-.3-3-4.5-3.4-7l2-.3c.4 2.3 1.1 4.6 1.7 5.2c.3-.3.6-.8.7-1.1c.1-.3-.4-1.3-.7-1.9c-.5-1.1-1-2.2-.8-3.2c.3-1.2 2.2-2.8 3-3.4l1.2 1.6c-1.1.9-2.2 2-2.3 2.3c-.1.3.4 1.3.7 1.8c.5 1.1 1 2.2.8 3.1c-.3.8-1.3 2.9-2.7 2.9"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 36.6c-1.4-.9-3.2-.7-4.5.6c-1.4 1.6-1.4 4.1 0 5.6c1.4 1.6 3.8 1.6 5.2 0c1.2-1.3 1.4-3.3.6-4.8l9.6-10.2l1.3 1.4l1.3-1.4l-2.6-2.8l-10.9 11.6",
    fill: "#dbb471"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3 39.4c.3-.3.3-.8 0-1.2s-.8-.3-1.2 0c-.3.3-.3.8 0 1.2c-.3-.3-.8-.3-1.2 0c-.3.3-.3.8 0 1.2c.3.3.8.3 1.2 0c-.3.3-.3.8 0 1.2c.3.3.8.3 1.2 0s.3-.8 0-1.2c.3.3.8.3 1.2 0c.3-.3.3-.8 0-1.2c-.4-.3-.9-.3-1.2 0",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 36.6c1.4-.9 3.2-.7 4.5.6c1.4 1.6 1.4 4.1 0 5.6c-1.4 1.6-3.8 1.6-5.2 0c-1.2-1.3-1.4-3.3-.6-4.8l-9.6-10.2l-1.3 1.4l-1.3-1.4l2.6-2.8l10.9 11.6",
    fill: "#d0d0d0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7 39.4c-.3-.3-.3-.8 0-1.2c.3-.3.8-.3 1.2 0c.3.3.3.8 0 1.2c.3-.3.8-.3 1.2 0c.3.3.3.8 0 1.2c-.3.3-.8.3-1.2 0c.3.3.3.8 0 1.2c-.3.3-.8.3-1.2 0s-.3-.8 0-1.2c-.3.3-.8.3-1.2 0c-.3-.3-.3-.8 0-1.2c.4-.3.9-.3 1.2 0",
    fill: "#ffffff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ed4c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4 39.8c-2.9.4-5.9.4-8.8 0c-.6-.1-.8.6-.2.7c3.1.5 6.2.5 9.3 0c.6-.2.3-.8-.3-.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3 39.2c-1.8-1.3-3.4-2.9-4.7-4.7c-.3-.4-.8-.1-.5.2c1.4 1.9 3.1 3.6 5 5c.3.3.6-.2.2-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4 34.5c-1.3 1.8-2.9 3.4-4.7 4.7c-.4.3-.1.8.2.5c1.9-1.4 3.6-3.1 5-5c.3-.3-.2-.5-.5-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 31h1v13h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.481 33.436l.708-.707l2.404 2.404l-.707.708z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.411 35.062l2.404-2.404l.707.707l-2.404 2.404z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff717f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5 42.7c-.6 0-1 .4-1 1v3h2v-3c0-.5-.4-1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5 41.8c-.6 0-1 .4-1 1v3h2v-3c0-.6-.4-1-1-1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#94989b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.6,
    cy: 37.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.8,
    cy: 42.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.8,
    cy: 37.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.6,
    cy: 42.9,
    r: 1.2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#dbb471"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.2,
    cy: 37.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.4,
    cy: 42.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.4,
    cy: 37.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.2,
    cy: 42.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1 20.9h2v2.2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9 20.9h2v2.2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.577 28.624l.607-2.218l.58.158l-.608 2.219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.386 27.408l.16-.579l1.542.425l-.159.578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2 26.532l.578-.158l.608 2.218l-.58.158z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.95 27.212l1.543-.424l.16.579l-1.543.424z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 28.1l-1.7 1.5l-1.1-3.1l1.7-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 28.1l1.7 1.5l1.1-3.1l-1.7-.9z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#dbb471"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5 26.5l-.6-.2l-.1.5l-.4-.1l-.2.6l.4.1l-.2 1.1l.5.2l.3-1.1l.5.1l.1-.6l-.4-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8 27.3l-.2-.6l-.4.1l-.1-.5l-.6.2l.1.5l-.4.1l.1.6l.5-.1l.3 1.1l.5-.2l-.2-1.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForVaticanCity);
export default __webpack_public_path__ + "static/media/flag-for-vatican-city.ecdaf1482dee9141b39ca126bbb7a752.svg";
export { ForwardRef as ReactComponent };